// extracted by mini-css-extract-plugin
export default {"wrapper":"DashboardSidebar_wrapper__aXJjY","schedule":"DashboardSidebar_schedule__SAuL-"};